import {Modal, Button, Form} from "react-bootstrap";
import {useState, useMemo} from "react";
import {useDispatch} from "react-redux";
import API from "../helpers/api";

export default function ChangePasswordModal({accountId, close}){
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [passwords, setPasswords] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pageState, setPageState] = useState(0);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswords(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (passwords.newPassword !== passwords.confirmPassword) {
            alert("Passwords do not match.");
            return;
        }
        setIsSubmitting(true);
        try {
            const response = await api.changeUserPassword(accountId, passwords.newPassword);
            if (response) {
                setPageState(1);
            } else {
                alert("Failed to change password. Please try again.");
            }
        } catch (error) {
            console.error('Error changing password:', error);
            alert("Unable to change password. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    }

    let body = null;

    if (pageState === 0) {
        body = (
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="newPassword">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                        type="password"
                        name="newPassword"
                        value={passwords.newPassword}
                        onChange={handleChange}
                        required
                        minLength={8}
                        placeholder="Enter new password"
                        disabled={isSubmitting}
                    />
                    <Form.Text className="text-muted">
                        Password must be at least 8 characters long.
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3" controlId="confirmPassword">
                    <Form.Label>Confirm New Password</Form.Label>
                    <Form.Control
                        type="password"
                        name="confirmPassword"
                        value={passwords.confirmPassword}
                        onChange={handleChange}
                        required
                        minLength={8}
                        placeholder="Confirm new password"
                        disabled={isSubmitting}
                    />
                </Form.Group>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Changing Password...' : 'Change Password'}
                </Button>
            </Form>
        );
    } else if (pageState === 1) {
        body = (
            <div className="text-center">
                <h5>Password changed successfully!</h5>
                <p><strong>New Password: </strong> {passwords.newPassword}</p>
                <Button variant="primary" onClick={close}>
                    Close
                </Button>
            </div>
        );
    }

    return (
        <Modal show onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Change Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {body}
            </Modal.Body>
        </Modal>
    );
}